"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pages_common_1 = require("@qwilr/pages-common");
var projectTotalWatcher = function ($rootScope, quoteDataStore) {
    return $rootScope.$watch(function () { return quoteDataStore.pageTotalPayToday; }, function (total) {
        pages_common_1.PubSub.publish("qwilr:quote-total-changed", { total: total });
    });
};
exports.default = projectTotalWatcher;
